import { ManagerConfirmPreparationMutation, ManagerConfirmPreparationMutationVariables } from './../../../types'
import { MANAGER_CONFIRM_PREPARATION } from '../Queries'
import { client } from '../../..'

export const managerConfirmPreparation = async (meetingId: string): Promise<void> => {
  await client.mutate<ManagerConfirmPreparationMutation, ManagerConfirmPreparationMutationVariables>({
    mutation: MANAGER_CONFIRM_PREPARATION,
    variables: {
      meetingId: meetingId,
    },
    update: (_store, { data }) => {
      if (!data || !data.managerConfirmPreparation) {
        throw new Error('Invalid UpdateMeetingFeedback mutation')
      }
    },
  })
}
